module.exports = __webpack_public_path__ + "static/media/logo_tvanhanguera.2e854428.png";